<template lang="pug">
.row.meeting-time(v-if="section.meeting_times")
    | {{ t("helpers.label.section.meeting_times")}}: {{ section.meeting_times }}
</template>
<script>
export default {
  props: ['section']
}
</script>